import { useContext } from 'react';
import { GameContext } from 'contexts/GameContext';
import { Paragraph } from 'elements/Text';

const Author = () => {
  const { title } = useContext(GameContext);

  return (
    <Paragraph>{title}</Paragraph>
  );
}

export default Author;
